import {
  config
} from '../_config'
import {
  authHeader,
  handleResponse
} from '../_helpers'

export const expoDocsSvr = {
  todosTipos,
  eliminarDoc
}

function todosTipos() {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },

  }

  return fetch(`${config.apiUrl}/doctype`, requestOptions).then(handleResponse)

}

function eliminarDoc(id) {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },

  }

  return fetch(`${config.apiUrl}/deleteDoc/${id}`, requestOptions).then(handleResponse)
}


function addNewExpoDateInscr(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr`, requestOptions).then(handleResponse)

}

function editExpoDateInscr(datos) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr/${datos.id}`, requestOptions).then(handleResponse)

}

function deleteExpoDateInscr(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr/${id}`, requestOptions).then(handleResponse)

}
